import React, { useState } from "react";
import "./App.css";
import { Route, BrowserRouter, Routes, Link } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Certificates from "./pages/Certificates";
import Collaboration from "./pages/Collaboration";
import Projects from "./pages/Projects";
import Links from "./pages/Links";
import Resume from "./pages/Resume.js";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <BrowserRouter>
      <div>
        <nav className="navbar">
          <div className={`hamburger ${isMenuOpen ? "active" : ""}`} onClick={toggleMenu}>
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
          </div>
          <ul className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
            <li>
              <Link to="/about" onClick={toggleMenu}>About</Link>
            </li>
            <li>
              <Link to="/projects" onClick={toggleMenu}>Project</Link>
            </li>
            <li>
              <Link to="/collaboration" onClick={toggleMenu}>Collab</Link>
            </li>
            <li>
              <Link to="/resume" onClick={toggleMenu}>Resume</Link>
            </li>
            <li>
              <Link to="/links" onClick={toggleMenu}>Links</Link>
            </li>
            <li>
              <Link to="/certificates" onClick={toggleMenu}>Certs</Link>
            </li>
            <li>
              <Link to="/" onClick={toggleMenu}>Home</Link>
            </li>
          </ul>
        </nav>
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/links" element={<Links />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/collaboration" element={<Collaboration />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;


